import menu from "./menu/index.json";
import global from "./global.json";
import page from "./pages";
import tab from "./tab.json";
import field from "./field.json";
import R from "./result.json";
export default { menu, ...global, page, tab, field, R };
